import { useState } from "react";
import { useStyles } from "./EditProfile.style";
import {
  Button,
  Header,
  Icon,
  TextField,
  Typography,
  TypographyColor,
  TypographyVariant,
  useCustomNavigate,
  CircularProgress,
} from "@onmo/ui";
import { useEditProfile } from "../../hooks/useEditProfile";
import { useTranslation } from "react-i18next";

const EditProfile: React.FC = () => {
  const classes = useStyles();
  const { handleBack } = useCustomNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { onUpdateUser, handleUsername, username, isDisabled } =
    useEditProfile();

  const updateUser = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await onUpdateUser();
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <div className={classes.editProfile}>
      <Header
        leftElement={
          <Icon name="icon-linear-arrow-left-3" onClick={() => handleBack()} />
        }
        title={t("edit_username")}
      />
      <div className={classes.container}>
        <div className={classes.userName}>
          <TextField
            fullWidth
            placeholder={t("username_placeholder")}
            label={t("username")}
            onChangeValue={handleUsername}
            inputProps={{
              value: username,
            }}
          />
          {(!username || username?.length === 0) && (
            <Typography
              variant={TypographyVariant.BodyB6Regular}
              color={TypographyColor.Text2}
            >
              {t("username_helper_text")}
            </Typography>
          )}
          {username && username.length < 3 && (
            <Typography
              variant={TypographyVariant.BodyB6Regular}
              color={TypographyColor.TextError}
            >
              {t("common_Username need at least 3 characters")}
            </Typography>
          )}
        </div>
      </div>
      <Button
        className={classes.btn}
        disabled={isDisabled}
        onClick={updateUser}
      >
        {isLoading ? (
          <CircularProgress enableAnimation borderLight size={18} />
        ) : (
          t("update")
        )}
      </Button>
    </div>
  );
};
export default EditProfile;
